export default {
  nome: null,
  document: null,
  tipoPessoa: null,
  email: null,
  dataNascimento: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/associatemodel.js